/**
 * created by st
 */
let servers = {
    dev: 'http://localhost:8080',
    test: 'https://regard01.95579.com',
    pro: 'https://u.95579.com'
}

let cjServices = {}

// 获取图形验证码
cjServices.getValidateImg = (context) => context.$http.get(servers[context.env] + '/cjscweb/activity/goldCJGetValidateImg.do')

// 查询推荐部门-字符模糊搜索匹配
cjServices.qryRecommendDepartment = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/queryDeptInfo.do',
    params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})
// 根据名称搜索出长江证券部门名称
// cjServices.getDepatement = (context, params) => context.$https.post(servers[context.env] + 'cjscweb/activity/queryDeptInfo.do',
// params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})
// 根据图形验证码获取短信验证码
cjServices.sendCode = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/goldCJSendCode.do',
    params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 提交私募组／专业组
cjServices.goldSubmit = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/goldCJSubmit.do',
    params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 登录接口
cjServices.login = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/goldCJLogin.do',
params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 通过token查询上周我已经提交私募产品净值数据
cjServices.getDataList = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/preweekNetValueCheck.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})

// excel文件上传
cjServices.uploadExc= (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/importExcel.do',
params, {headers: {'Content-Type': 'multipart/form-data'}, emulateJSON: true})

//  pdf上传
cjServices.uploadPdf= (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/uploadFile.do',
params, {headers: {'Content-Type': 'multipart/form-data'}, emulateJSON: true})

// pdf删除
cjServices.deletePdf = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/deletePDFFile.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})


// 周度报送净值提交接口，逐个产品提交
cjServices.netValueSubmit = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/submitPreweekNetValue.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})

// 获取排名
cjServices.rankList = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/netValueOrder.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})

// 名称模糊搜索
cjServices.selectNameList = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/goldCJProductNameSearch.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})

// 通过token查询我的私募产品，以及上月我已经提交私募产品净值数据
cjServices.getMonthDataList = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/premonthNetValueCheck.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})

// 月度报送净值提交接口，逐个产品提交
cjServices.monthValueSubmit = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/submitPremonthNetValue.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})


// 验证邮箱的校验规则
cjServices.checkEmail = (value) => {
  const regEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
  return value !== '' && regEmail.test(value)
}

// 长江机构名称搜索
cjServices.organizationName = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceManagerSerach.do',
params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 旧产品策略组字典
cjServices.policyGroup = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceProdStrategy.do',
params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}, emulateJSON: true})

// 新产品策略组字典
cjServices.newPolicyGroups = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/getStrategyNew.do',
  params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 产品数据状态
cjServices.getNewProData = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/getRegProdData.do',
  params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 删除产品数据
cjServices.deleteOneProData = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/deleteProductInfo.do',
  params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 机构搜索
cjServices.cjRaceManage = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceManagerSerach.do',
  params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 产品搜索
cjServices.productSerach = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceProductSerach.do',
  params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 回显对应私募机构信息
cjServices.showProData = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/getEchoOrganInfo.do',
  params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 产品名称搜索
cjServices.productNameSerach = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceProductSerach.do',
params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 推荐部门模糊搜索
cjServices.departSerach = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceRecommendDept.do',
params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 感兴趣业务
cjServices.interestedBusiness = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/cjRaceInterestedBusi.do',
params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

// 赛事报道
cjServices.getRaceBaodao = (context, params) => context.$http.get(servers[context.env] + '/cjscweb/activity/cjRaceReportInfoWebQry.do',{params} , {headers: {'Content-Type': 'application/json'}, emulateJSON: false})
// 验证手机号的校验规则
cjServices.checkMobile = (value) => {
  // 去除空格
  value = value.replace(/\s/g, "");
  const regMobile = /^1[0-9]{10}$/;
  return value.length > 0 && regMobile.test(value)
}

// 未报名成功提示状态查询
cjServices.getManagerRegStatus = (context, params) => context.$http.post(servers[context.env] + '/cjscweb/activity/getManagerRegStatus.do',
params, {headers: {'Content-Type': 'application/json'}, emulateJSON: false})

export default cjServices
